<template>
  <v-dialog v-model="seeMore">
    <v-card flat dark>
      <v-toolbar dense flat dark>
        {{ story.title }}
        <v-spacer />
        <v-btn small icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-carousel cycle height="400" hide-delimiter-background show-arrows-on-hover>
          <v-carousel-item v-for="(image, i) in story.images" :key="i">
            <v-img :src="image" alt="cabin pic" height="400" contain />
          </v-carousel-item>
        </v-carousel>
      </v-card-text>
      <v-card-text>
        <div>{{ story.description }}</div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      seeMore: false,
      story: {}
    }
  },
  methods: {
    open(story) {
      this.story = story || {},
      this.seeMore = true
    },
    close() {
      this.seeMore = false,
      this.images = []
    }
  }
}
</script>